// extracted by mini-css-extract-plugin
export default {"viewMore":"index_viewMore_y9x6T","viewMoreLink":"index_viewMoreLink_AamVs"};